export const ModuleAccess = 1201
export const Administration = 1202
export const RunProcess = 1203
export const AccessToAllPricessInstances = 1204
export const AccessToStatistics = 1205
export const AccessToAllTasks = 1206
export const CancelTasks = 1207

export const RightsMap: Record<number, string> = ({
  [ModuleAccess]: 'Доступ к модулю',
  [Administration]: 'Администрирование модуля (настройки, права доступа)',
  [RunProcess]: 'Право запускать процессы',
  [AccessToAllPricessInstances]: 'Право просматривать все запущенные процессы',
  [AccessToStatistics]: 'Доступ к статистике',
  [AccessToAllTasks]: 'Право просматривать все задачи',
  [CancelTasks]: 'Право отменять задачи',
})
